/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
/* eslint-disable no-invalid-this */
// CONSTANTS are all caps.
const NS = 'SiteHeaderWoolLab';
const CLS = 'siteHeaderWoolLab';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/siteHeaderWoolLab.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'

import {loadSearchBar} from '../loadWg/searchBar';
import utils from '../utils';

const $win = $(window);
const $doc = $(document);

export class SiteHeaderWoolLab {
	constructor($el) {
		// $el is the widget node return by the loadSiteHeaderWoolLab function
		this.$el = $($el);
	}

	init() {
		// this.checkMinified();
		this.setSiteHeaderWoolLab();
		this.setSearchBar();
		this.setSticky();
		$('.siteHeaderWoolLab').addClass('is-ready');
		// this.setAnimations();
		// this.onScrollMinify();
		this.onResizeAdjustHeaderContentWidth();
		this.setHeaderBottomFix();
		this.setupMegaMenu();
		this.setupSubMenu();
		// this.checkAccMenuToggle();
	}

	setHeaderBottomFix() {
		const headerWrap = document.querySelector('.homePage-headerWrap');

		if (headerWrap) {
			const firstElement = document.querySelector('#mainContent').children[0];
			let firstEleHeight = firstElement.clientHeight + 'px';

			if (firstElement.className.indexOf('homeHero') === -1) {
				document.querySelector('#mainContent').children[0].style.marginBottom = '60px';
			}

			headerWrap.style.top = firstEleHeight;
			$(window).resize(function() {
				firstEleHeight = firstElement.clientHeight + 'px';
				headerWrap.style.top = firstEleHeight;
			});
		} else {
			this.addTopSpacing();
		}
	}

	setSiteHeaderWoolLab() {
		// Add Some logic here
		const wg = this.$el;
		const navBarToggle = this.$el.find(WG + 'navbarToggle');
		const megaMenu = this.$el.find(WG + 'megaMenu');
		const mmBackBtn = this.$el.find(WG + 'mmBackBtn');

		navBarToggle.on('click', function(e) {
			wg.toggleClass('is-mbExpanded');
			$(this).toggleClass('is-collapsed');
		});

		mmBackBtn.on('click', function(e) {
			// e.stopPropagation();
			megaMenu.removeClass('is-megaMenuOpen');
		});
	}

	setSearchBar() {
		loadSearchBar(document.body).then((wg) => {
			wg ? wg.init() : '';
		});
	}

	setSticky() {
		// let This = this;
		let stickyToggle = function(sticky, stickyWrapper, scrollElement) {
			let stickyHeight = sticky.outerHeight();
			let stickyTop = stickyWrapper.offset().top;

			if (scrollElement.scrollTop() >= stickyTop) {
				stickyWrapper.height(stickyHeight);
				sticky.addClass('is-sticky');
			} else {
				sticky.removeClass('is-sticky');
				stickyWrapper.height('auto');
			}

			// on mobile, always stick?
			// if (This.isOnMobile()) {
			// 	stickyWrapper.height(stickyHeight);
			// 	sticky.addClass('is-sticky');
			// }
		};

		// needs to timeout to avoid double call (which happens intermittently)
		setTimeout(() => {
			// Find all data-toggle="sticky-onscroll" elements
			$('[data-toggle="sticky-onscroll"]').each(function() {
				let sticky = $(this);
				let stickyWrapper = $('<div>').addClass('sticky-wrapper'); // insert hidden element to maintain actual top offset on page
				sticky.before(stickyWrapper);
				sticky.addClass('sticky');

				// Scroll & resize events
				// window won't work as expected, document will span the full content
				$doc.on('scroll.sticky-onscroll resize.sticky-onscroll', function() {
					stickyToggle(sticky, stickyWrapper, $(this));
				});

				// On page load
				stickyToggle(sticky, stickyWrapper, $win);
			});
		}, 0);
	}

	// User clicks on logo for collapsing header.
	// Pre-condition: user is on desktop size, the header in mobile size is always expanded.
	minifyHeader(duration = 250) {
		let wg = this.$el;
		let nav = wg.find(WG + 'nav');
		let content = wg.find(WG + 'contents');
		let logoWrapper = wg.find(WG + 'logoWrapper');
		let logo = wg.find(WG + 'logo');
		let logoWidth = logo.width();
		let paddingForLogoLeftSide = 13;
		let paddingForLogoBothSides = 26;
		let logoDisplayedArea = logoWidth + paddingForLogoBothSides;
		let logoWrapperWidth = 70 - logoWidth - paddingForLogoLeftSide;

		nav.css({
			overflow: 'hidden',
		});

		// Important for "overflow: hidden" nav.
		content.width(utils.getWindowWidth());

		// Collapsing nav.
		nav.animate({
			width: logoDisplayedArea + 'px',
			left: logoWrapperWidth + 'px',
		}, duration);
		// Move logo to the displaying area.
		content.animate({
			left: '-' + logoWrapperWidth + 'px',
		}, duration);
	}

	// User clicks on logo for expanding header.
	// Pre-condition: the header is collapsing.
	expandHeader() {
		let wg = this.$el;
		let nav = wg.find(WG + 'nav');
		let content = wg.find(WG + 'contents');

		// check if previous animations are done
		// if (nav.is(':animated') || content.is(':animated')) return;

		// Expanding the nav.
		nav.stop().animate({
			width: '100%',
			left: '0px',
		}, () => {
			nav.css({
				overflow: 'visible',
			});
		});

		// Expanding the inner content.
		content.stop().animate({
			left: '0px',
			width: utils.getWindowWidth(),
		}, () => {
			// content.width('100%');
			// content.width(window.innerWidth - 15);
		});
	}

	isOnMobile() {
		return utils.getWindowWidth() < 992;
	}

	// Click on logo to minify/expand the header.
	setAnimations() {
		let wg = this.$el;
		// let nav = wg.find(WG + 'nav');
		// eslint-disable-next-line no-unused-vars
		let content = wg.find(WG + 'contents');
		let logoHit = wg.find(WG + 'logoHit');

		// User clicks on logo for collapse/expand header.
		logoHit.on('mouseover', () => {
			// On mobile, the collapsed nav is auto expanded because we don't have collapsed nav on mobile size.
			if (this.isOnMobile()) {
				if (wg.hasClass('is-minified')) {
					wg.removeClass('is-minified');
					this.expandHeader();
				}
				return;
			}

			// Collapse/expand header.
			// we should check if there is a previous animation that didn't finish yet
			wg.toggleClass('is-minified');
			if (wg.hasClass('is-minified')) this.minifyHeader();
			else this.expandHeader();
		});

		// When user resizes browsers,
		// ensure that if in mobile size, the header must be expanded.
		$win.resize(() => {
			if (this.isOnMobile()) {
				if (wg.hasClass('is-minified')) {
					wg.removeClass('is-minified');
					this.expandHeader();
				}
				return;
			}
		});

		//
		// window.onscroll = (e) => {
		// 		const $sec = $('#mainContent').find(':nth-of-type(2)');
		// 		const secBottom = $sec.position().top + $sec.outerHeight();
		// 		let winBottom = $(window).scrollTop() + $(window).height();
		// 		// If sec is completely visible in the window, fade in
		// 		if (winBottom > secBottom) {
		// 			this.minifyHeader();
		// 		}
		// };
		// End
	}

	checkMinified() {
		const isMinified = this.$el.hasClass('is-minified');

		if (isMinified && !this.isOnMobile()) {
			this.minifyHeader();
		}
	}

	onScrollMinify() {
		const _this = this;
		const $logoHit = this.$el.find(WG + 'logoHit');
		const $homePage = $('.homePage');
		// homePage??
		if ($('.main').length > 0) {
			$win.on('scroll', function() {
				const scrollTop = $win.scrollTop();
				const docHeight = $doc.height();
				const winHeight = $win.height();
				const scrollPercent = (scrollTop) / (docHeight - winHeight);
				const scrollPercentRounded = Math.round(scrollPercent * 100);

				if ($homePage.length > 0) {
					const mainOffset = $homePage.offset().top;

					if (!_this.$el.hasClass('is-minified') && scrollPercentRounded > 40) {
						// $(window).off('scroll');
						// _this.minifyHeader();
						// Trigger synthetic click event instead of using minifyHeader() as a quick-fix
						$logoHit.trigger('mouseover');
					} else if (_this.$el.hasClass('is-minified') && mainOffset >= scrollTop) {
						$logoHit.trigger('mouseover');
					}
				} else {
					if (!_this.$el.hasClass('is-minified') && scrollPercentRounded > 20) {
						// $(window).off('scroll');
						// _this.minifyHeader();
						// Trigger synthetic click event instead of using minifyHeader() as a quick-fix
						$logoHit.trigger('mouseover');
					}
				}
			});
		}
	}

	// Add more functions like on above here

	onResizeAdjustHeaderContentWidth() {
		let This = this;
		$win.on('resize', function() {
			let wg = $(This.$el);
			let content = wg.find(WG + 'contents');
			// let nav = wg.find(WG + 'nav');

			// Expanding the inner content.
			content.width(utils.getWindowWidth());
			// removed the animation on resize as it created temporary scroll bars
			// content.stop().animate({
			// 	width: utils.getWindowWidth()
			// });
		});
	}

	setupMegaMenu() {
		let megaMenu = $(WG + 'megaMenu');
		megaMenu.find(WG + 'megaMenuContent').hide();
		let $hb = $('html, body');

		megaMenu.on('mouseover', function(e) {
			e.preventDefault();
			e.stopPropagation();
			const that = this;

			$(megaMenu).removeClass('is-megaMenuOpen');


			let megaMenuContent = $(this).find('.siteHeaderWoolLab-megaMenuContent');
			$(that).addClass('is-megaMenuOpen');

			// add slide down effect
			// once slide animation is completed, check if the full height of the mega menu is visible, if not, scroll down to show the full height of the mega menu.
			megaMenuContent.slideDown('fast', function() {
				const winBottom = $win.height();
				let megaMenuContentOffset = megaMenuContent.offset().top - $win.scrollTop();
				let megaMenuContentOuterHeight = megaMenuContent.outerHeight();
				// console.log("megaMenuContentOffset", megaMenuContentOffset);
				// console.log("megaMenuContentOuterHeight", megaMenuContentOuterHeight);
				let posDiff = winBottom - megaMenuContentOffset;
				if (posDiff >= 0 && posDiff < megaMenuContentOuterHeight) {
					let scrollAdjust = megaMenuContentOuterHeight - posDiff;
					$hb.animate({
						scrollTop: $win.scrollTop() + scrollAdjust,
					}, 500);
				}
			});
		});

		megaMenu.on('mouseleave', function(e) {
			$(megaMenu).removeClass('is-megaMenuOpen');
			megaMenu.find('.siteHeaderWoolLab-megaMenuContent').hide();
		});

		$(WG + 'megaMenuContent').on('click', function(e) {
			e.stopPropagation();
		});

		$win.on('click', function() {
			megaMenu.removeClass('is-megaMenuOpen');
			megaMenu.find('.siteHeaderWoolLab-megaMenuContent').hide();
		});
	}

	addTopSpacing() {
		let wg = this.$el;

		if (wg.hasClass('is-minified')) return;

		let mainContent = document.querySelector('#mainContent');
		let padTop = wg.height();
		$(mainContent).css('padding-top', `${padTop}px`);
	}

	checkAccMenuToggle() {
		let $wg = this.$el;
		let $userMenu = $wg.find(`${WG}accMenuList`);

		setInterval(() => {
			if ($userMenu.hasClass('show')) {
				let transformValues = $userMenu[0].style.transform;
				if (transformValues && transformValues !== '') {
					let transformArr = transformValues.replace(/(translate3d)*[()]/g, '');
					transformArr = transformArr.split(',');
					if (transformArr.length === 3) {
						let x = -$userMenu.width() + 'px';
						let y = transformArr[1];
						let z = transformArr[2];
						$userMenu[0].style.transform = `translate3d(${x}, ${y}, ${z})`;
					}
				}
			}
		}, 100);
	}

	setupSubMenu() {
		const This = this;
		let $wg = this.$el;

		$wg.on('click', WG + 'link', function(e) {
			let currentList = $(this).closest('li');

			if (currentList.find(WG + 'submenu').length > 0 && This.isOnMobile()) {
				e.preventDefault();
				$(this).hide(0);

				currentList.find(WG + 'submenu').toggleClass('show');
				$wg.find(WG + 'linksList > li').not(currentList).hide(0);

				$wg.find(WG + 'mmBackBtn').toggleClass('show');
			}
		});

		$wg.on('click', WG + 'mmBackBtn', function() {
			$wg.find(WG + 'submenu.show')
				.removeClass('show')
				.prev(WG + 'link')
				.show(0);

			$wg.find(WG + 'linksList > li').show(0);

			$wg.find(WG + 'mmBackBtn').toggleClass('show');
		});
	}
}
